module.exports = __webpack_public_path__ + "static/thumb-6-a1a8cdfe1366d0946224069aee3b8dcd.jpg";